<template>
  <form @submit.prevent="validateBeforeSubmit">
    <div class="modal-card" style="width: 640px">
      <header class="modal-card-head">
        <p class="modal-card-title">{{ title }}</p>
      </header>
      <section class="modal-card-body">
        <b-field label="ID" v-if="id">
          <b-input placeholder="ID" disabled v-model="model.id"></b-input>
        </b-field>
        <b-field label="Дата регистрации"
          :type="{'is-danger': errors.has('date')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('date', 'required')
          }]">
          <b-datepicker
            name="date"
            placeholder="Выберите дату"
            icon="calendar-alt"
            v-validate="'required'"
            v-model="model.date">
          </b-datepicker>
        </b-field>
        <b-field
          label="Наименование">
          <b-input
            name="name"
            placeholder="Наименование"
            icon="building"
            icon-pack="fa"
            v-model="model.name">
          </b-input>
        </b-field>
        <b-field label="Адрес"
          :type="{'is-danger': errors.has('address')}"
          :message="[{
            'Обязательное поле для заполнения' : errors.firstByRule('address', 'required')
          }]">
          <b-input
            type="textarea"
            name="address"
            minlength="5"
            maxlength="256"
            placeholder="Адрес"
            v-validate="'required'"
            v-model="model.address">
          </b-input>
        </b-field>
        <b-field
          label="Электронной почта"
          :type="{'is-danger': errors.has('email')}"
          :message="[{
            'Адрес электронной почты обязательное поле для заполнения' : errors.firstByRule('email', 'required')
          }]">
            <b-input
              name="email"
              placeholder="Email"
              type="email"
              icon="at"
              v-validate="'required'"
              v-model="model.email">
            </b-input>
        </b-field>
        <b-field
          label="Телефон">
          <b-input
            name="phone"
            placeholder="Телефон"
            icon="phone"
            v-model="model.phone">
          </b-input>
        </b-field>
        <b-field
          label="ИНН"
          :type="{'is-danger': errors.has('inn')}"
          :message="[{
            'Имя обязательное поле для заполнения' : errors.firstByRule('inn', 'required'),
            'Минимальная длина ИНН 10 цифр для физлица, 12 цифр для юрлица' : errors.firstByRule('inn', 'min'),
            'Максимальная длина ИНН 12 цифр' : errors.firstByRule('inn', 'max')
          }]">
            <b-input
              name="inn"
              placeholder="ИНН"
              icon="address-card"
              icon-pack="fa"
              v-validate="'required|min:10|max:12'"
              v-model="model.inn">
            </b-input>
        </b-field>
        <b-field
          label="ОГРН"
          :type="{'is-danger': errors.has('orgn')}"
          :message="[{
            'Имя обязательное поле для заполнения' : errors.firstByRule('orgn', 'required'),
            'Минимальная длина ОГРН 13 цифр' : errors.firstByRule('orgn', 'min'),
            'Максимальная длина ОГРН 13 цифр' : errors.firstByRule('orgn', 'max')
          }]">
            <b-input
              name="orgn"
              placeholder="ОГРН"
              icon="address-card"
              icon-pack="fa"
              v-validate="'required|min:13|max:13'"
              v-model="model.orgn">
            </b-input>
        </b-field>
        <b-field
          label="КПП"
          :type="{'is-danger': errors.has('kpp')}"
          :message="[{
            'Имя обязательное поле для заполнения' : errors.firstByRule('kpp', 'required'),
            'Минимальная длина КПП 9 цифр' : errors.firstByRule('kpp', 'min'),
            'Максимальная длина КПП 9 цифр' : errors.firstByRule('kpp', 'max')
          }]">
            <b-input
              name="kpp"
              placeholder="КПП"
              icon="address-card"
              icon-pack="fa"
              v-validate="'required|min:9|max:9'"
              v-model="model.kpp">
            </b-input>
        </b-field>
      </section>
      <footer class="modal-card-foot">
        <button class="button is-primary">Сохранить</button>        
        <button class="button" type="button" @click="$parent.close()">Закрыть</button>
      </footer>
    </div>
  </form>
</template>

<script>
import Vue from 'vue'
import VeeValidate from 'vee-validate'

Vue.use(VeeValidate, {
    events: '',
});

import { EventBus } from '@/utils'

export default {
  name: 'CompanyForm',
  components: {
    //
  },
  props: {
    id: Number,
    title: String
  },
  data: function () {
    return {
      model: {
        id: undefined
      },
      purge_model: {
        id: undefined
      }
    }
  },
  created: function() {
    //
  },
  computed: {
    //
  },
  beforeMount: function(){
    //
  },
  mounted () {
    let $this = this

    if ($this.id){
      this.$store.dispatch('getCompany', $this.id)
        .then(response => {
          let data = response.data.data;
          for(let propertyName in data) {
            if(propertyName != "date"){
              $this.model[propertyName] = data[propertyName]
            }
            else{
              $this.model[propertyName] = new Date(data[propertyName])
            }
          }
        })
        .catch(error => {
          this.model = this.purge_model
        })
    }
  },
  methods: {
    validateBeforeSubmit() {
      let $this = this
      this.$validator.validateAll().then((result) => {
        if (result) {
          $this.doUpdate()
          return;
        }
        this.$toast.open({
          message: $this.$i18n.t('notify.form_error'),
          type: 'is-danger',
          position: 'is-bottom'
        })
      });
    },
    doUpdate () {
      let $this = this
      if ($this.id){
        $this.$store.dispatch('updateCompany', $this.model)
      }
      else{
        $this.$store.dispatch('createCompany', $this.model)
      }
    }
    
  }
}
</script>

<style scoped>
</style>
<style>
</style>